import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { axios, APIBASE_REVIVERAPPLICATION } from "./ApiConfig";
import { DashboardStatistics } from "@/types";

const getOrderByTransactionId = (from: string, to: string) =>
  axios.get<DashboardStatistics>(`${APIBASE_REVIVERAPPLICATION}api/statistics/dashboardStatistics`, {
    params: {
      from,
      to,
    },
  });

export const useGetDashboardStatistics = (
  from: string,
  to: string,
  options?: Partial<UseQueryOptions<DashboardStatistics>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery({
    queryKey: ["dashboardStatistics", from, to],
    queryFn: async () => {
      const result = await getOrderByTransactionId(from, to);
      return result.data;
    },
    ...queryOptions,
  });
};
